import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import { Error } from 'types'
import Input from 'components/shared/Input'

interface IProps {
  error: Error | string
  deviceID: string
  shipTo: string
  equipment: string
  handleDeviceIdChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  handleShipToChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  handleEquipmentChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  handleRegister: () => void
}

const TankRegistration = ({
  error,
  deviceID,
  shipTo,
  equipment,
  handleRegister,
  handleDeviceIdChange,
  handleShipToChange,
  handleEquipmentChange,
}: IProps) => (
  <Grid container direction="column">
    <Grid container item justify="center">
      <Box mb={{ xs: 5 }}>
        <Typography variant="h2" color="secondary">
          Register Device
        </Typography>
      </Box>
    </Grid>
    <form
      name="register"
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        handleRegister()
      }}
    >
      <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
        <Box p={{ xs: 3, md: 4, lg: 6 }}>
          <Grid item>
            <Typography variant="body1" color="error">
              {error}
            </Typography>
          </Grid>
          <Grid item>
            <Input label="Device ID" value={deviceID} onChange={handleDeviceIdChange} />
          </Grid>
          <Grid item>
            <Input label="Ship To" value={shipTo} onChange={handleShipToChange} />
          </Grid>
          <Grid item>
            <Input label="Equipment Number" value={equipment} onChange={handleEquipmentChange} />
          </Grid>
          <Grid item>
            <Box pt={{ xs: 2, sm: 4 }}>
              <Button
                fullWidth
                type="submit"
                variant="contained"
                disabled={!deviceID || (!shipTo && !equipment)}
                onClick={handleRegister}
              >
                <Typography variant="h4" color="primary">
                  Register
                </Typography>
              </Button>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </form>
  </Grid>
)

export default React.memo(TankRegistration)
